export default "__VITE_ASSET__5857645f__"